<template>
  <div class="py-4">
    <div class="mb-8" v-for="e in visibleElements" :key="e.key">
      <div v-if="e.format.answerType === 'sectionLabel'">
        <h2>{{ e.format.label }}</h2>
      </div>

      <div v-else>
        <h4 class="text-primary">
          {{ e.format.label }} {{ e.format.isRequired ? "*" : "" }}
        </h4>
        
        <div v-if="e.format.answerType === 'shortText'">
          <v-text-field
            variant="outlined"
            density="compact"
            hide-details
            :model-value="e.value"
            @update:model-value="inputValue($event, e)"
          ></v-text-field>
        </div>
        
        <div v-else-if="e.format.answerType === 'mediumText'">
          <v-textarea
            variant="outlined"
            density="compact"
            hide-details
            :model-value="e.value"
            @update:model-value="inputValue($event, e)"
          ></v-textarea>
        </div>
        
        <div v-else-if="e.format.answerType === 'longText'">
          <v-textarea
            variant="outlined"
            density="compact"
            hide-details
            :model-value="e.value"
            @update:model-value="inputValue($event, e)"
          ></v-textarea>
        </div>
        
        <div v-else-if="e.format.answerType === 'number'">
          <v-text-field
            variant="outlined"
            density="compact"
            hide-details
            type="number"
            :model-value="e.value"
            @update:model-value="inputValue($event, e)"
          ></v-text-field>
        </div>
        
        <div v-else-if="e.format.answerType === 'date'">
          <date-picker
            :model-value="e.value"
            @update:model-value="inputValue($event, e)"
          ></date-picker>
        </div>
        
        <div v-else-if="e.format.answerType === 'singleSelect'">
          <v-select
            variant="outlined"
            density="compact"
            hide-details
            :model-value="e.value"
            :items="e.format.options"
            item-title="label"
            item-value="value"
            @update:model-value="inputValue($event, e)"
          ></v-select>
        </div>
        
        <div v-else-if="e.format.answerType === 'multiSelect'">
          <v-select
            variant="outlined"
            density="compact"
            hide-details
            multiple
            :model-value="e.value"
            :items="e.format.options"
            item-title="label"
            item-value="value"
            @update:model-value="inputValue($event, e)"
          ></v-select>
        </div>
        
        <div v-else-if="e.format.answerType === 'boolean'">
          <v-checkbox
            :model-value="e.value"
            :label="e.format.label"
            @update:model-value="inputValue($event, e)"
            hide-details
            density="compact"
          ></v-checkbox>
        </div>
        
        <div v-else-if="e.format.answerType === 'month'">
          <month-picker
            :model-value="e.value"
            @update:model-value="inputValue($event, e)"
          ></month-picker>
        </div>
        
        <div v-else>
          <div>{{ e.format.answerType }}</div>
          <div>{{ e }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ChildInfoData } from "chaild-api/lib";
import { defineComponent, PropType } from "vue";

import DatePicker from "@/components/atoms/DatePicker.vue";
import MonthPicker from "@/components/atoms/MonthPicker.vue";

export default defineComponent({
  components: {
    DatePicker,
    MonthPicker,
  },

  // ⭕️ 発行する独自イベント名を定義します
  emits: ["update-info"],

  props: {
    elements: {
      type: Array as PropType<ChildInfoData[]>,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },

  computed: {
    visibleElements(): ChildInfoData[] {
      const kanaKeys = new Set([
        "addressKana",
        "medicalCenterAddressKana",
        "medicalCenterKana",
      ]);
      return this.elements.filter((e) => {
        if (kanaKeys.has(e.key)) return false;
        const lab = e.format.label.trim();
        if (/\bkana\b/i.test(lab)) return false;
        if (/フリガナ/u.test(lab)) return false;
        return true;
      });
    },
  },

  methods: {
    inputValue(value: any, element: ChildInfoData) {
      const newEl = { ...element };
      newEl.value = value;
      // ⭕️ Vue 2 の input イベントは非推奨になったため、独自の update-info に変更
      this.$emit("update-info", newEl);
    },
  },
});
</script>